/**
 *  Module for pricing and availability for US and EU locales.
 */

const Availability = function (app) {

  /**
   *  Private Properties/Methods
   */
  const configure = app.configure,
    _ = require('lodash'),
    $ = require('jquery');;

  function checkProductOverrides({ data = [] }, styleNumbers, styleFacetsId) {
    if (data === null) {
      data = [];
    }

    app.performance.mark('configure:ola:loaded');

    if (!app.mergedParams.currency) {
      app.mergedParams.currency = configure.run('getCurrency');
    }
    const productOverrides = {
      debug: false,
      values: {},
      renderInactive: {
        style_fit_and_size: true,
        style_fit_color_and_size: true
      }
    };
    let omit = [];
    const localeFacetFilter = app.mergedParams.facetFilters.filter(facetFilter => facetFilter.facet === 'locale')[0].facetValue.toLowerCase();
    const size = configure.run('getAttribute', { alias: 'size' });
    const values = size.values;
    // First create to the object with all the values deactivated.
    for (let i = 0; i < values.length; i++) {
      const value = values[i];
      const facets = value.facets;
      const facetsKeys = Object.keys(facets);
      const facetsLength = facetsKeys.length;

      const localeFacet = app.mergedParams.localeFacet.toLowerCase();
      for (let j = 0; j < facetsLength; j++) {
        const facet = facets[facetsKeys[j]];
        for (let k = 0; k < facet.length; k++) {
          if (styleFacetsId.indexOf(facet[k]) !== -1 && localeFacetFilter === localeFacet) {
            productOverrides.values[value.vendorId] = {
              valueUsages: {}
            };
            productOverrides.values[value.vendorId].valueUsages[value.vendorId] = {
              active: false
            };
          }
        }
      }
    }
    // For internal testing. Add the ability to omit values and test
    // the On-Load Availability features. Pass a comma separated
    // e.g. &omitValues=0038703518
    const omitValues = String(app.mergedParams.omitValues);
    if (app.isFluidEnv() && omitValues) {
      if (omitValues.indexOf(',') >= 0) {
        omit = omitValues.split(',');
      } else {
        omit = [omitValues];
      }
      console.log('omit', omit);
    }
    for (const item of data) {
      // If stock_level === 0 then the item is unavailable
      let valueUsages = {};
      const inventory = item.inventory;
      const forceProduct = !!_.size(_.filter(omit, function (o) {
        return o === item.id;
      }));

      if (inventory.stock_level > 0 || !forceProduct) {
        // Only add the value if it is relevant to the current product.
        // We can find that because we first create the productOverrides with all
        // the values deactivated.
        if (productOverrides.values[item.id] && productOverrides.values[item.id].valueUsages[item.id]) {
          productOverrides.values[item.id].valueUsages[item.id].active = item.master.orderable;
          productOverrides.values[item.id].valueUsages[item.id].upcharge = {};
          productOverrides.values[item.id].valueUsages[item.id].upcharge[app.mergedParams.currency] = item.master.price;
        }
        if (item.variants) {
          for (const variant of item.variants) {
            const forceVariant = !!_.size(_.filter(omit, function (o) {
              return o === variant.product_id;
            }));

            if (!forceVariant &&
              // Only add the value if it is relevant to the current product.
              // We can find that because we first create the productOverrides with all
              // the values deactivated.
              productOverrides.values[variant.product_id] &&
              productOverrides.values[variant.product_id].valueUsages[variant.product_id]) {
              productOverrides.values[variant.product_id].valueUsages[variant.product_id].active = variant.orderable;
              productOverrides.values[variant.product_id].valueUsages[variant.product_id].upcharge = {};
              productOverrides.values[variant.product_id].valueUsages[variant.product_id].upcharge[app.mergedParams.currency] = variant.price;
            }
          };
        }
      } else {
        valueUsages = { active: false };
        productOverrides.values[item.id] = {
          valueUsages
        };
      }
    }
    return productOverrides;
  }

  function checkAvailability(styleNumbers, styleFacetsId, callback) {
    let url = '';
    const avail = app.mergedParams.Avail;

    if (avail) {
      url = window.decodeURIComponent(avail).replace('( )', `(${styleNumbers})`);
    } else {
      let baseUrl = 'https://rldapi-v.ralphlauren.com';

      if (app.mergedParams.workflow !== 'prod' && !app.mergedParams.forceProdOla) {
        baseUrl = 'https://dev-rldapi.ralphlauren.com/';
      }

      url = baseUrl + '/s/RalphLauren_US/dw/shop/v17_7/products/('
        + styleNumbers
        + ')?pretty_print=true&expand=availability,prices,variations&client_id=26266021-445d-4475-a12d-ac1295cdcdcb';
    }
    if (app.mergedParams.useEmptyFeed && app.isFluidEnv()) {
      return callback(checkProductOverrides({}, styleNumbers, styleFacetsId));
    }

    $.ajax({
      url,
      dataType: 'jsonp',
      cache: true,
      jsonpCallback: 'jsonCallback'
    }).done(function (data) {
      callback(checkProductOverrides(data, styleNumbers, styleFacetsId));
    }).fail(function () {
      console.warn('Unable to load availability data.');
      callback(checkProductOverrides({}, styleNumbers, styleFacetsId));
    });
  }

  /**
   *  Expose Public Properties/Methods
   */
  return {
    checkAvailability
  };
};

module.exports = Availability;
